"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchWithFallbacks = void 0;
const axios_1 = __importDefault(require("axios"));
const fetchWithFallbacks = async (args) => {
    const requests = args.urls.map((url) => axios_1.default.get(url, args.axiosConfig));
    const response = await Promise.any(requests);
    return response;
};
exports.fetchWithFallbacks = fetchWithFallbacks;
//# sourceMappingURL=fetch-with-fallback.js.map